import {Component, Input} from '@angular/core';
import {CommonModule} from "@angular/common";
import {GuidelineStatusIconComponent} from "../guideline-status-icon/guideline-status-icon.component";
import {
    IGuideLineSuggestion
} from "../../../../general-editor-tabs/legal-hub/suggestion-sidebar/suggestion-sidebar.component";

export interface IPlaybookGuidelineRunItem{
    id:number,
    status?: PlaybookGuidelineStatusEnum;
    content: string;
    details?:IGuideLineSuggestion;
}

export enum PlaybookGuidelineStatusEnum{
    MET = "met",
    NOT_MET = "not_met",
    MISSING = "missing",
    PROCESSING = "processing",
    FAILED = "failed"
}

@Component({
  selector: 'app-playbook-guideline-run-tile',
  standalone: true,
    imports: [
        CommonModule,
        GuidelineStatusIconComponent
    ],
  templateUrl: './playbook-guideline-run-tile.component.html',
  styleUrl: './playbook-guideline-run-tile.component.scss'
})
export class PlaybookGuidelineRunTileComponent {
    @Input({required:true}) guideline: IPlaybookGuidelineRunItem;
    @Input() playbookRunning: boolean = false;
}
